import { ICTTitle, DeltaOf } from '@tencent/slide-sdk-model';
import {
    IChartTitle,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { ChartShapeInfoConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/common/chart-shape-info-converter';
import { ChartLayoutConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/common/chart-layout-converter';
import { DeepPartial, DeepReadonly } from 'ts-essentials';

export class ChartTitleConverter {
    public static convertPartialDataSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTTitle>>,
        uiData: IChartTitle,
    ) {
        // 标题默认文本属性、图形样式
        ChartShapeInfoConverter.convertPartialDataFromSdkToUi(sdkData, uiData as IShapeModel);

        // 自定义标题文本属性
        if (sdkData.tx?.rich) {
            uiData.text = {};
            ChartShapeInfoConverter.convertTxBodySdkToUi(sdkData.tx.rich, uiData.text as IShapeModel);
        } else {
            delete uiData.text;
        }

        // 是否覆盖在图表上
        if (sdkData.overlay !== undefined) {
            uiData.overlay = sdkData.overlay.val;
        }

        // 标题布局
        if (sdkData.layout !== undefined) {
            uiData.layout = uiData.layout || {};
            ChartLayoutConverter.convertPartialDataFromSdkToUi(sdkData.layout, uiData.layout);
        } else {
            delete uiData.layout;
        }
    }

    public static convertPartialDataUiToSdk(
        uiData: DeepPartial<IChartTitle>,
        sdkData: DeltaOf<ICTTitle>,
    ) {
        // 标题默认文本属性、图形样式
        ChartShapeInfoConverter.convertPartialDataFromUiToSdk(uiData as IShapeModel, sdkData);

        // 自定义标题文本属性
        if (uiData.text) {
            sdkData.tx = sdkData.tx ?? {};
            sdkData.tx.rich = sdkData.tx.rich ?? {};

            ChartShapeInfoConverter.convertTxBodyUiToSdk(uiData.text as IShapeModel, sdkData.tx.rich);
        }

        // 是否覆盖在图表上
        if (uiData.overlay !== undefined) {
            sdkData.overlay = { val: uiData.overlay };
        }

        // 标题布局
        if (uiData.layout !== undefined) {
            if (!uiData.layout) {
                sdkData.layout = null;
            } else {
                sdkData.layout = sdkData.layout ?? {};
                ChartLayoutConverter.convertPartialDataFromUiToSdk(uiData.layout, sdkData.layout);
            }
        }
    }
}
